import { ZUid } from "src/types/zUid";

/**
 * Сторож устаревших данных объекта.
 *
 * Ключ кэша (версия модели, пользователь, язык) не входит в ключ ресурса: иначе
 * записи под старыми ключами копились бы в памяти. Вместо этого он сравнивается
 * в момент обращения — то есть по действию пользователя, без фоновых
 * перезагрузок.
 *
 * Отметка ставится до ожидания ответа. Если поставить после, два параллельных
 * обращения сбросят запросы друг друга, и вместо одного обращения к сети выйдет
 * два.
 */
export class CacheGuard {
  private readonly seen = new Map<string, string>();

  constructor(private readonly currentKey: () => string) {}

  /**
   * Устарели ли данные по этому объекту. Заодно запоминает текущий ключ, так
   * что повторный вопрос до смены ключа ответит «нет».
   */
  isStale(objectId: ZUid): boolean {
    const id = String(objectId);
    const key = this.currentKey();
    const known = this.seen.get(id);
    this.seen.set(id, key);
    return known !== undefined && known !== key;
  }

  /** Данные получены иным путём: отметка нужна, вопрос — нет. */
  remember(objectId: ZUid) {
    this.seen.set(String(objectId), this.currentKey());
  }

  forget(objectId: ZUid) {
    this.seen.delete(String(objectId));
  }

  clear() {
    this.seen.clear();
  }
}
